export enum SocketEvent {
  WALLET_REQUEST_FAILED = 'wallet_requests.failed',
  WALLET_REQUEST_CREATED = 'wallet_requests.created',
  WALLET_CREATED = 'wallets.created',
  BANK_ACCOUNT_STATUS_CHANGE = 'bank_accounts.status_change',
  PROFILE_STATUS_CHANGE = 'profiles.status_change',
  TRANSACTION_CREATED = 'transactions.created',
  TRANSACTION_FAILED = 'transactions.failed',
  TRANSACTION_FINISHED = 'transactions.finished',

  APPLICANT_REVIEWED = 'applicants.reviewed',
  BANK_ACCOUNT_CREATED = 'bank_accounts.created',
  PROFILE_CREATED = 'profiles.created',

  NOTIFICATION = 'notification',
}
